/** CSS contract: css-library/components/03-layouts/wizard.css. */
import type { HTMLAttributes, ReactNode, Ref } from 'react';
import { cx } from '../lib/cx';
import { Modal } from './Modal';

export interface WizardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onClose' | 'role'> {
  onClose: () => void;
  bar?: ReactNode;
  scrollRef?: Ref<HTMLDivElement>;
  overlay?: ReactNode;
}

export function Wizard(
  { ref, bar, scrollRef, overlay, className, children, onClose, ...rest }: WizardProps & { ref?: Ref<HTMLDivElement> },
) {
  return (
    <Modal ref={ref} size="document" topbar={bar} onClose={onClose} className={className} {...rest}>
      <div className="wizard-scroll" ref={scrollRef}>{children}</div>
      {overlay}
    </Modal>
  );
}

export interface WizardPageProps extends HTMLAttributes<HTMLElement> {
  narrow?: boolean;
}

export function WizardPage(
  { ref, narrow = false, className, children, ...rest }: WizardPageProps & { ref?: Ref<HTMLElement> },
) {
  return (
    <main ref={ref} className={cx('wizard-page', narrow && 'is-narrow', className)} {...rest}>
      {children}
    </main>
  );
}

export type WizardFooterProps = HTMLAttributes<HTMLElement>;

export function WizardFooter(
  { ref, className, children, ...rest }: WizardFooterProps & { ref?: Ref<HTMLElement> },
) {
  return (
    <footer ref={ref} className={cx('wizard-footer', className)} {...rest}>
      <span className="wizard-footer-spacer" />
      {children}
    </footer>
  );
}
